export default "__VITE_ASSET__43c23ebe__"